/// <reference types="vite/client" />
// Detect if we are on localhost or LAN to adjust API URL
const hostname = window.location.hostname;
const API_URL_VAR = import.meta.env.VITE_API_URL?.replace(/\s/g, '');
export const API_BASE_URL = API_URL_VAR || "https://paddle-backend.mvpapplifab.workers.dev/api";

// 2. Detection logic
const isLocal = hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.startsWith("192.168.") ||
    hostname.startsWith("10.") ||
    hostname.startsWith("172.");

// Staging detection: hostname-based fallback
const isStaging = hostname.includes('staging') ||
    hostname.includes('preview') ||
    (hostname.endsWith('.pages.dev') && hostname.split('.').length > 3);

export let API_URL: string;

if (isLocal) {
    // In local dev, we usually use the proxy /api
    API_URL = '/api';
} else if (API_URL_VAR) {
    // If VITE_API_URL is explicitly provided (env file or build arg), use it
    API_URL = API_URL_VAR;
} else if (isStaging) {
    API_URL = "https://paddle-backend-staging.mvpapplifab.workers.dev/api";
} else {
    // Default to production
    API_URL = "https://paddle-backend.mvpapplifab.workers.dev/api";
}

console.log("🔧 API Configured:", API_URL);

// Helper for Auth Headers
export const getAuthHeaders = (): Record<string, string> => {
    const token = localStorage.getItem('token');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};
